import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  Button,
  IconButton,
  Paper,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Add, Delete, Edit } from "@mui/icons-material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { uploadImage } from "services/imageUpload";
import { IMAGE_URL } from "network";
import {
  useGetSubCatBasedColorQuery,
  useGetSubCatBasedSizeQuery,
} from "slices/eCommerce/shopProducts";
import { deleteImage } from "services/imageUpload";

const Variations = ({ values, onChange }) => {
  const [openModal, setOpenModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [newItem, setNewItem] = useState({
    size: "",
    color: "",
    price: "",
    stock: "",
    sku: "",
    discount: "",
    media: [],
  });

  const { data: colors } = useGetSubCatBasedColorQuery(values.subCategory, {
    skip: !values.subCategory,
  });
  const { data: size } = useGetSubCatBasedSizeQuery(values.subCategory, {
    skip: !values.subCategory,
  });

  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  const resetModal = () => {
    setNewItem({
      uses_count: "",
      size: "",
      color: "",
      price: "",
      stock: "",
      sku: "",
      discount: "",
      media: [],
    });
    setEditIndex(null);
    setOpenModal(false);
  };

  const handleAddOrEditItem = () => {
    const updatedVariations = [...(values?.variations || [])];
    if (editIndex !== null) {
      updatedVariations[editIndex] = newItem;
    } else {
      updatedVariations.push(newItem);
    }

    onChange(updatedVariations); // ✅ Use onChange
    resetModal();
  };

  const handleDeleteItem = (index) => {
    const updated = values?.variations.filter((_, i) => i !== index);
    onChange(updated);
  };

const handleDeleteItemMedia = (mediaIndex) => {
  // 1️⃣ Update local modal state
  setNewItem((prev) => {
    const updatedMedia = prev.media.filter((_, i) => i !== mediaIndex);

    // 2️⃣ Update parent variation array immediately if editing an existing one
    if (editIndex !== null) {
      const updatedVariations = [...values.variations];
      updatedVariations[editIndex] = {
        ...updatedVariations[editIndex],
        media: updatedMedia,
      };
      onChange(updatedVariations);
    }

    return { ...prev, media: updatedMedia };
  });
};


  const handleEditItem = (index) => {
    setEditIndex(index);
    setNewItem(values.variations[index]);
    setOpenModal(true);
  };

  useEffect(() => {
    if (values?.variations.length > 0 && sliderRef.current) {
      // Scroll to last slide
      sliderRef.current.slickGoTo(values?.variations?.length - 1);
    }
  }, [values?.variations]);

  const delmedia = async (image) => {
    // setDeletedFiles(image);
    await deleteImage(image);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>
        Product Variations
      </Typography>

      <Box sx={{ py: 2 }}>
        <Slider ref={sliderRef} {...sliderSettings}>
          {values.variations.map((item, index) => (
            <div key={index}>
              <Paper sx={{ mx: 1, p: 2, position: "relative" }}>
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    gap: 1,
                  }}
                >
                  <IconButton onClick={() => handleEditItem(index)}>
                    <Edit color="primary" />
                  </IconButton>
                  <IconButton onClick={() => handleDeleteItem(index)}>
                    <Delete color="error" />
                  </IconButton>
                </Box>

                <Typography variant="subtitle1" fontWeight="bold" mt={1}>
                  SKU: {item.sku}
                </Typography>
                <Typography variant="body2">Price: ₹{item.price}</Typography>
                <Typography variant="body2">Stock: {item.stock}</Typography>
                <Typography variant="body2">
                  Uses Count: {item.uses_count}
                </Typography>
                <Typography variant="body2">
                  Discount: {item.discount}%
                </Typography>

   <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
  {item.media?.map((mediaItem, idx) => (
    <Box
      key={idx}
      sx={{
        position: "relative",
        width: 60,
        height: 60,
      }}
    >


      {/* Image or Video */}
      {mediaItem.type === "image" ? (
        <img
          src={`${IMAGE_URL}${mediaItem.url}`}
          alt={`media-${idx}`}
          crossOrigin="anonymous"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 4,
          }}
        />
      ) : (
        <video
          src={`${IMAGE_URL}${mediaItem.url}`}
          crossOrigin="anonymous"
          controls
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 4,
            objectFit: "cover",
          }}
        />
      )}
    </Box>
  ))}
</Box>

              </Paper>
            </div>
          ))}

          <div>
            <Paper
              onClick={() => {
                setEditIndex(null);
                setNewItem({
                  size: "",
                  color: "",
                  price: "",
                  stock: "",
                  sku: "",
                  discount: "",
                  media: [],
                });
                setOpenModal(true);
              }}
              sx={{
                mx: 1,
                height: 200,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                border: "2px dashed #ccc",
              }}
            >
              <Add fontSize="large" />
              <Typography>Add Variation</Typography>
            </Paper>
          </div>
        </Slider>
      </Box>

      <Modal open={openModal} onClose={resetModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            {editIndex !== null ? "Edit Variation" : "Add Variation"}
          </Typography>

          <FormControl fullWidth margin="normal">
            <InputLabel id="color-label">Select Color</InputLabel>
            <Select
              labelId="color-label"
              label="Color"
              name="color"
              value={newItem.color}
              onChange={(e) =>
                setNewItem({ ...newItem, color: e.target.value })
              }
            >
              {colors?.data?.map((c) => (
                <MenuItem key={c._id} value={c._id}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal" required>
            <InputLabel id="size-label">Select Size</InputLabel>
            <Select
              labelId="size-label"
              label="Size"
              name="size"
              value={newItem.size}
              onChange={(e) => setNewItem({ ...newItem, size: e.target.value })}
            >
              {size?.data?.map((s) => (
                <MenuItem key={s._id} value={s._id}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Price"
            type="number"
            value={newItem.price}
            onChange={(e) => setNewItem({ ...newItem, price: e.target.value })}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Discount (%)"
            type="number"
            value={newItem.discount}
            onChange={(e) =>
              setNewItem({ ...newItem, discount: e.target.value })
            }
            fullWidth
            margin="normal"
          />

          <TextField
            label="Stock Count"
            type="number"
            value={newItem.stock}
            onChange={(e) => setNewItem({ ...newItem, stock: e.target.value })}
            fullWidth
            margin="normal"
          />

          {values.productFor === "beautician" && (
            <TextField
              label="Uses Count"
              type="number"
              value={newItem.uses_count}
              onChange={(e) =>
                setNewItem({ ...newItem, uses_count: e.target.value })
              }
              fullWidth
              margin="normal"
            />
          )}

          <TextField
            label="SKU"
            type="number"
            value={newItem.sku}
            onChange={(e) => setNewItem({ ...newItem, sku: e.target.value })}
            fullWidth
            margin="normal"
          />

          <input
            type="file"
            multiple
            accept="image/*,video/*"
            onChange={async (e) => {
              const files = Array.from(e.target.files);
              const uploadedMedia = [];

              for (let index = 0; index < files.length; index++) {
                try {
                  const res = await uploadImage(files[index]);
                  const fileType = files[index].type.startsWith("image")
                    ? "image"
                    : "video";
                  uploadedMedia.push({ type: fileType, url: res });
                } catch (err) {
                  console.error("Upload failed for", files[index].name, err);
                }
              }

              setNewItem((prev) => ({
                ...prev,
                media: [...prev.media, ...uploadedMedia],
              }));
            }}
          />

          {/* ✅ Display uploaded or existing media */}
          <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
  {newItem.media.map((mediaItem, index) => (
    <Box
      key={index}
      position="relative"
      width={60}
      height={60}
      sx={{ borderRadius: 1, overflow: "hidden" }}
    >
      {/* Delete Icon */}
 <IconButton
  onClick={(e) => {
    e.stopPropagation();
    handleDeleteItemMedia(index);
    delmedia(mediaItem.url);
  }}
  sx={{
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "rgba(255,255,255,0.7)",
    "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
  }}
  size="small"
>
  <Delete color="error" fontSize="small" />
</IconButton>


      {/* Media Preview */}
      {mediaItem.type === "image" ? (
        <img
          crossOrigin="anonymous"
          src={`${IMAGE_URL}${mediaItem.url}`}
          alt={`edit-media-${index}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <video
          crossOrigin="anonymous"
          src={`${IMAGE_URL}${mediaItem.url}`}
          controls
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      )}
    </Box>
  ))}
</Box>

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" onClick={resetModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddOrEditItem}
              disabled={
                // !newItem.uses_count ||
                !newItem.size ||
                !newItem.price ||
                !newItem.stock ||
                !newItem.sku
              }
            >
              {editIndex !== null ? "Update" : "Add"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Variations;
